import { action as apiAction } from 'api/Api'
import {
  removeItem as removeItemFromChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  checklistItemId: number
  checklistId: number
  userId?: number
  statusId?: number
  template?: any
}

const requestConvertChecklistItemToCard = (payload: Payload) => async dispatch => {
  const { checklistItemId, checklistId, statusId, userId, template } = payload

  const args: any = {
    checklistItemId,
    userId,
    template,
  }
  if (statusId) {
    args.cardTarget = {
      statusId,
      statusPosition: 'top'
    }
  }

  const optimisticAction = optimisticDispatch(dispatch, removeItemFromChecklist({
    elementId: checklistId,
    itemId: checklistItemId
  }))

  try {
    await apiAction('ConvertChecklistItemToCard', args)

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestConvertChecklistItemToCard
